import React, { useState } from 'react';
// import UserHome from './components/UserHome';
// import UserChat from './components/UserChat';
import AdminPanel from './components/AdminPanel';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('admin-panel'); // Directly admin panel
  const [user, setUser] = useState({
    user_id: 'USER_12345',
    name: 'John Doe', 
    mobile: '9876543210'
  });
  const [chatType, setChatType] = useState(null);
  const [ticketId, setTicketId] = useState(null);

  // Static admin data
  const staticAdmin = {
    admin_id: 'ADMIN_001',
    username: 'admin',
    email: 'admin@support.com',
    role: 'superadmin'
  };

  const handleUserChatStart = (type, ticket_id) => {
    setChatType(type);
    setTicketId(ticket_id);
    setCurrentView('user-chat');
  };

  const handleUserBackToHome = () => {
    setCurrentView('user-home');
  };

  const switchToAdmin = () => {
    setCurrentView('admin-panel');
  };

  const switchToUser = () => {
    setCurrentView('user-home');
  };

  return (
    <div className="App">
      {/* Simple Header */}
      <div className="app-header">
        <div className="header-content">
          <h1 className="app-title">💬 Support System</h1>
          <div className="header-actions">
            <button 
              onClick={switchToUser} 
              className={`switch-btn ${currentView === 'user-home' || currentView === 'user-chat' ? 'active' : ''}`}
            >
              👤 User
            </button>
            <button 
              onClick={switchToAdmin} 
              className={`switch-btn ${currentView === 'admin-panel' ? 'active' : ''}`}
            >
              🔧 Admin
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}

        
        {currentView === 'admin-panel' && (
          <AdminPanel 
            admin={staticAdmin}
            onLogout={switchToUser}
          />
        )}
      </div>
    // </div>
  );
}

export default App;